import React from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";

import { I18nProvider, ROUTE_SEGMENTS } from "@/i18n";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import { PrivacyPage, CookiesPage, TermsPage } from "@/pages/LegalPages";

function Layout() {
  return (
    <I18nProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-[#FAF9F5]">
        <Header />
        <div className="flex-1">
          <Outlet />
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

function ThankYouLayout() {
  return (
    <I18nProvider>
      <ScrollToTop />
      <Outlet />
    </I18nProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/mx" replace />} />

        {/* Thank you: Spanish-only, no header/footer chrome */}
        <Route element={<ThankYouLayout />}>
          <Route path="/thank_you" element={<ThankYou />} />
        </Route>

        {/* Spanish routes */}
        <Route path="/mx" element={<Layout />}>
          <Route index element={<Home />} />
          <Route
            path={ROUTE_SEGMENTS.privacy.mx}
            element={<PrivacyPage />}
          />
          <Route
            path={ROUTE_SEGMENTS.cookies.mx}
            element={<CookiesPage />}
          />
          <Route
            path={ROUTE_SEGMENTS.terms.mx}
            element={<TermsPage />}
          />
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* English routes */}
        <Route path="/en" element={<Layout />}>
          <Route index element={<Home />} />
          <Route
            path={ROUTE_SEGMENTS.privacy.en}
            element={<PrivacyPage />}
          />
          <Route
            path={ROUTE_SEGMENTS.cookies.en}
            element={<CookiesPage />}
          />
          <Route
            path={ROUTE_SEGMENTS.terms.en}
            element={<TermsPage />}
          />
          <Route path="*" element={<NotFound />} />
        </Route>

        <Route path="*" element={<Navigate to="/mx" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
